/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );

export const getSingleOrdinanceRevision = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_ORDINANCE_REVISION,
    `api/v1/rpt/administrator/settings/ordinance_revisions/${id}`,
    payload,
    callback
  );

export const createOrdinanceRevision = (payload, callback) =>
  req.create(
    c.CREATE_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateOrdinanceRevision = (id, payload, callback) =>
  req.update(
    c.UPDATE_ORDINANCE_REVISION,
    `api/v1/rpt/administrator/settings/ordinance_revisions/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeOrdinanceRevision = (id, payload, callback) =>
  req.remove(
    c.REMOVE_ORDINANCE_REVISION,
    `api/v1/rpt/administrator/settings/ordinance_revisions/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );
